import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import MediaPlayer from './components/MediaPlayer';
import StreamList from './components/StreamList';
import Footer from './components/Footer';

const SPORT_ICONS = {
  baseball: '⚾', basketball: '🏀', soccer: '⚽', football: '🏈',
  tennis: '🎾', volleyball: '🏐', hockey: '🏒', golf: '⛳',
  boxing: '🥊', mma: '🥋', rugby: '🏉', cricket: '🏏',
  badminton: '🏸', swimming: '🏊', cycling: '🚴', default: '📺',
};

/**
 * Decodes the base64 HLS URL from the mplayer.php wrapper, then routes it
 * through the backend proxy if REACT_APP_BACKEND_URL is set.
 *
 * Flow:
 *   videosUrl  →  mplayer.php?v=BASE64
 *   BASE64     →  https://liveh.winner-stream.com/xxx.m3u8  (raw HLS)
 *   proxy URL  →  https://<backend>/proxy/hls?url=BASE64(rawHLS)
 *
 * The backend (running on the Hostinger whitelisted IP) fetches the stream
 * and rewrites segment URLs so all HLS traffic stays server-side.
 */
function getStreamUrl(videosUrl) {
  if (!videosUrl) return '';

  // Step 1 – extract the real HLS URL from the mplayer.php wrapper
  let hlsUrl = videosUrl;
  try {
    const parsed = new URL(videosUrl);
    const v = parsed.searchParams.get('v');
    if (v) hlsUrl = atob(v);
  } catch (_) {}

  // Step 2 – route through backend proxy if configured
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return `${backendUrl}/proxy/hls?url=${btoa(hlsUrl)}`;
  }

  // Fallback: direct URL (works in dev; will hit CORS in production)
  return hlsUrl;
}

function App() {
  const [selected, setSelected] = useState(null);

  const handleSelect = (stream) => {
    setSelected(stream);
    document.getElementById('watch')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const streamSrc = selected ? getStreamUrl(selected.videosUrl) : '';

  return (
    <div className="app">
      <Header />
      <main>
        {/* ── Watch section ── */}
        <section className="watch-section" id="watch">
          <div className="watch-section__inner">

            {/* Player panel */}
            <div className="watch-panel watch-panel--player">
              {selected ? (
                <>
                  <div className="now-playing">
                    <span className="now-playing__icon">
                      {SPORT_ICONS[selected.icon] || SPORT_ICONS.default}
                    </span>
                    <div className="now-playing__text">
                      <h2 className="now-playing__title">{selected.name}</h2>
                      <p className="now-playing__meta">
                        {selected.description}
                        {selected.schedule_time ? ` · ${selected.schedule_time}` : ''}
                      </p>
                    </div>
                    <span className="now-playing__badge">● 라이브</span>
                  </div>
                  <MediaPlayer
                    key={selected.videosUrl}
                    src={streamSrc}
                    title={selected.name}
                  />
                </>
              ) : (
                <div className="player-placeholder">
                  <div className="player-placeholder__inner">
                    <span className="player-placeholder__icon">📺</span>
                    <p className="player-placeholder__text">목록에서 라이브 스트림을 선택하세요</p>
                    <p className="player-placeholder__sub">라이브 이벤트는 빨간색으로 표시됩니다</p>
                  </div>
                </div>
              )}
            </div>

            {/* Stream list panel */}
            <aside className="watch-panel watch-panel--streams">
              <StreamList
                onSelect={handleSelect}
                selectedUrl={selected?.videosUrl}
              />
            </aside>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;

